import { render, staticRenderFns } from "./requests.vue?vue&type=template&id=7063b14d&scoped=true"
import script from "./requests.vue?vue&type=script&lang=ts"
export * from "./requests.vue?vue&type=script&lang=ts"
import style0 from "./requests.vue?vue&type=style&index=0&id=7063b14d&prod&lang=css"
import style1 from "./requests.vue?vue&type=style&index=1&id=7063b14d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7063b14d",
  null
  
)

export default component.exports